
import React from "react";

import { IKBSearchResult } from "../../../types/KB/IKBSearchResult";
import { useReduxDispatch, useReduxSelector } from "../../../redux/hooks";

import { Api, useGetTenantQuery } from "../../../redux/api/BaseApi";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import KBPreview from "./KBPreview";
import { SetLinkedKbs } from "../../../slices/TicketSlice";

import KBResults from "./KBResuilts";

const KnowledgeBase: React.FC = (props) => {
    const dispatch = useReduxDispatch();
    const { ticket } = useReduxSelector(state => state.newTicket);


    const kbSelected = (e: IKBSearchResult) => {
        const linkedKbs = ticket.Linked_Kb_Ids ? [...ticket.Linked_Kb_Ids] : [] as number[];
        //Add or remove element
        console.log('kbSelected', linkedKbs.indexOf(e.ID), linkedKbs.length)
        linkedKbs.indexOf(e.ID) === -1 ? linkedKbs.push(e.ID) : linkedKbs.splice(linkedKbs.indexOf(e.ID), 1)
        dispatch(SetLinkedKbs(linkedKbs));
    }
    const { results: kbResults } = useReduxSelector(state => state.kb);



    return <>
        <PanelBar>
            <PanelBarItem selected={true} expanded={true} title="Knowledge Base Results" >
                <KBResults results={kbResults} kbSelected={kbSelected} linkedKBIds={ticket.Linked_Kb_Ids} />
            </PanelBarItem>
        </PanelBar>
    </>

}

export default KnowledgeBase;